import React, { useState } from "react";
import { toast } from "react-toastify";
import { loadStripe } from "@stripe/stripe-js";
import Container from "@mui/material/Container";
import { useParams } from "react-router-dom";
import { PUBLIC_KEY_Stripe } from "config/config";
import {
  CardElement,
  useElements,
  Elements,
  useStripe,
} from "@stripe/react-stripe-js";
import axios from "axios";
import PaymentPage from "components/Cards/PaymentPage";
import PropTypes from 'prop-types';
import Tabs from '@mui/material/Tabs';
import Tab from '@mui/material/Tab';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import { createTheme, ThemeProvider } from '@mui/material/styles';
import CheckBalance from 'pages/CheckBalance';

const theme = createTheme({
  root: {
    flexGrow: 1,
    backgroundColor: 'white',
    display: 'flex',
    // marginTop: 20,
    // height: auto,
  },
  tabs: {
    borderRight: `1px solid white`,
  },
  textField: {
    width: 200,
  },
});

const PUBLIC_KEY = PUBLIC_KEY_Stripe;

const stripeTestPromise = loadStripe(PUBLIC_KEY);

function TabPanel(props) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role='tabpanel'
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <span className='text-white'>{children}</span>
        </Box>
      )}
    </div>
  );
}

TabPanel.propTypes = {
  children: PropTypes.node,
  index: PropTypes.number.isRequired,
  value: PropTypes.number.isRequired,
};

function a11yProps(index) {
  return {
    id: `simple-tab-${index}`,
    'aria-controls': `simple-tabpanel-${index}`,
  };
}

function Payment() {
  const [value, setValue] = React.useState(0);

  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  return (
    <Elements stripe={stripeTestPromise}>
      <Container maxWidth='sm'>
        <div className='center-styl my-10'>
          <img src={require('assets/img/newlogo.png')} />
        </div>
        <ThemeProvider theme={theme}>
          <Box sx={{ width: '100%' }}>
            <Box
              sx={{
                borderBottom: 1,
                // flex: 1,
                borderColor: 'divider',
                marginLeft: 10,
              }}
            >
              <Tabs
                value={value}
                onChange={handleChange}
                aria-label='basic tabs example'
                TabIndicatorProps={{
                  style: {
                    backgroundColor: 'white',
                  },
                }}
              >
                <Tab
                  label='Buy credits'
                  {...a11yProps(0)}
                  style={{
                    color: 'white',
                  }}
                />
                <Tab
                  label='Check balance'
                  {...a11yProps(1)}
                  style={{
                    color: 'white',
                  }}
                />
              </Tabs>
            </Box>
            <TabPanel value={value} index={0}>
              <div className='mx-10'>
                <PaymentPage />
              </div>
            </TabPanel>
            <TabPanel value={value} index={1}>
              <div className='mx-10'>
                <CheckBalance />
              </div>
            </TabPanel>
          </Box>
        </ThemeProvider>
      </Container>
    </Elements>
  );
}

export default Payment;
